import React, { useEffect } from 'react';

import { usePlaidLink } from 'react-plaid-link';

const OAuthLink = () => {
  // The Link token from the first Link initialization
  const linkToken = localStorage.getItem('link_token');

  const onSuccess = React.useCallback((public_token) => {
    console.log('Authenticated with plaid link, now lets get the accounts!', public_token);
    // send public_token to server, retrieve access_token and item_id
    // return to "https://example.com" upon completion
  });

  const onExit = (err, metadata) => {
    console.log('Failed to authenticate with plaid via oauth', err, metadata);
    // handle error...
  };

  const config = {
    token: linkToken,
    // pass in the received redirect URI, which contains an OAuth state ID parameter that is required to
    // re-initialize Link
    receivedRedirectUri: window.location.href,
    onSuccess,
    onExit,
  };

  const { open, ready, error } = usePlaidLink(config);

  // automatically reinitialize Link
  useEffect(() => {
    if (error) console.error(error?.message ?? error);
    if (ready) open();
  }, [ready, open, error]);

  // eslint-disable-next-line react/jsx-no-useless-fragment
  return <></>;
};

export default OAuthLink;
